import { render, staticRenderFns } from "./PasswordLessLoginForm.vue?vue&type=template&id=20256748&scoped=true&"
import script from "./PasswordLessLoginForm.vue?vue&type=script&lang=js&"
export * from "./PasswordLessLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordLessLoginForm.vue?vue&type=style&index=0&id=20256748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20256748",
  null
  
)

export default component.exports